import Switcher from './Switcher.component';
export default Switcher;